namespace RedBullMOBILE360.SMSCodes {
    export interface SubscriptionCodesRow {
        OfferId?: string;
        OfferName?: string;
        IsPrimary?: number;
        SubscriptionCode?: string;
        UnsubscriptionCode?: string;
        IsActive?: number;
        StopAtrnwCode?: string;
    }

    export namespace SubscriptionCodesRow {
        export const idProperty = 'OfferId';
        export const nameProperty = 'OfferId';
        export const localTextPrefix = 'SMSCodes.SubscriptionCodes';
        export const deletePermission = 'SMSCodes:SubscriptionCodes';
        export const insertPermission = 'SMSCodes:SubscriptionCodes';
        export const readPermission = 'SMSCodes:SubscriptionCodes';
        export const updatePermission = 'SMSCodes:SubscriptionCodes';

        export declare const enum Fields {
            OfferId = "OfferId",
            OfferName = "OfferName",
            IsPrimary = "IsPrimary",
            SubscriptionCode = "SubscriptionCode",
            UnsubscriptionCode = "UnsubscriptionCode",
            IsActive = "IsActive",
            StopAtrnwCode = "StopAtrnwCode"
        }
    }
}
